module.exports = __webpack_public_path__ + "img/content4-1.952524d3.webp";